<template>
  <div class="dash-preview">
    <div class="container">
      <b-modal id="modal-popup" size="sm" centered hide-header no-close-on-backdrop body-class="modal-popup">
        <div class="d-block text-center">
          <Icon name="grStars" width="36" class="mb-2"/>
          <h1 class="modal-title" v-if="title">{{ title }}</h1>
          <div class="position-relative">
            <div class="modal-popup__text scroll mt-3">
              <div v-html="text" v-if="text"></div>
              <template v-else>
                 <div class="placeholder__text mx-auto mb-3"
                           style="width: 60%;height: 10px;background: #FFFFFF;opacity:.2;margin-bottom: 6px"></div>
                 <div class="placeholder__text mx-auto" v-for="index in 6" :key="index"
                           style="width: 100%;height: 8px;background: #FFFFFF;opacity:.2;margin-bottom: 6px"></div>

              </template>
            </div>
            <div class="modal-popup__blur" v-if="text"></div>
          </div>
        </div>
        <div class="d-flex w-100 mt-3" v-if="langs.length > 0">
          <select v-model="modalType" class="form-control form-control-sm mr-2">
            <option v-for="type in modalTypes" :value="type.key" :key="type.key">{{ type.label }}</option>
          </select>
          <select v-model="lang" class="form-control form-control-sm">
            <option v-for="lang in langs" :value="lang" :key="lang">{{ lang }}</option>
          </select>
        </div>
        <template #modal-footer>
          <div class="d-block w-100">
            <b-button variant="primary" block>
              {{ $t('modal_popup.btn_ok') }}
            </b-button>
          </div>
        </template>
      </b-modal>
    </div>
  </div>
</template>


<script>
export default {
  name: 'PreviewPopup',
  props: {
    data: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      lang: null,
      modalType: null
    }
  },
  watch: {
    lang() {
      this.$i18n.locale = this.lang
    }
  },
  computed: {
    title() {
      if (!this.modalType || !this.lang) return ''
      return this.data[this.modalType + '_title'][this.lang]
    },
    text() {
      if (!this.modalType || !this.lang) return ''
      return this.data[this.modalType + '_text'][this.lang]
    },
    langs() {
      if (!this.modalType) return []
      return Object.keys(this.data[this.modalType +  '_text']);
    },

    modalTypes() {
      return [
        {key: 'welcome_popup', label: 'Welcome'},
        {key: 'fixed_popup', label: 'Fixed'},]
    },
  },
  async mounted() {
    await this.$nextTick()
    this.$bvModal.show('modal-popup')

    this.modalType = this.modalTypes[0].key
    this.lang = 'it'

  }
}
</script>
<style scoped>
.modal-popup__text.scroll {
  max-height: 364px;
}
</style>
